module.exports = __webpack_public_path__ + "static/media/litemeter.350fcc1a.svg";